import { useEffect, useRef, useState } from "react";
import { STAGES, TOKENS, fakeLaunch, fakePost } from "./data";

export function useCycle() {
  const [stage, setStage] = useState(0);
  const [cycle, setCycle] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => {
      if (stage === STAGES.length - 1) { setStage(0); setCycle((c) => c + 1); } else setStage((s) => s + 1);
    }, STAGES[stage].ms);
    return () => clearTimeout(t);
  }, [stage]);
  return { stage, cycle, token: TOKENS[cycle % TOKENS.length] };
}

export function useFeed(make, every, keep = 7) {
  const n = useRef(0);
  const [items, setItems] = useState(() => Array.from({ length: keep }, () => make(n.current++)));
  useEffect(() => {
    const t = setInterval(() => setItems((xs) => [make(n.current++), ...xs].slice(0, keep)), every);
    return () => clearInterval(t);
  }, [make, every, keep]);
  return items;
}

export function useScanned() {
  const [n, setN] = useState(184213);
  useEffect(() => {
    const t = setInterval(() => setN((x) => x + 3 + Math.floor(Math.random() * 9)), 400);
    return () => clearInterval(t);
  }, []);
  return n;
}

export const feeds = { launch: fakeLaunch, post: fakePost };
